import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ConfirmationModalPopupComponent } from 'src/app/core/confirmation-modal-popup/confirmation-modal-popup.component';
import { HaloCustomLoaderErrorType } from 'src/app/core/halo-custom-loader/halo-custom-loader.service';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { SelectionInfo } from '../../selectors/multi-selection/multi-selection.model';
import { ServicePageService } from '../service.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  maintenanceData: any[] = [];
  showDismissModal = false;
  showCompleteModal = false;
  showErrorCodesCompleteModal = false;
  customLoaderIsLoading = false;
  customLoaderErrorMsg: string;
  dismissPopupProperties = {
    title: 'PLS.CONFIRM',
    message: ['SERVICE.DISMISS.MESSAGE1', 'SERVICE.DISMISS.MESSAGE2'],
    ctaButtonLabel: 'YES',
    negativeButtonLabel: 'NO',
    isCloseIconCallsCta: false
  };
  pageOptions = [0,5,10,20];
  
  private currentFacility: FacilityObject;
  private sub = new Subscription();
  private selectionInfo: SelectionInfo;
  private selectedInspectBelt: any;
  private selectedErrorCodes: any;

  productWarrantyHintMsg = "VIEW.PRODUCT.WARRANTY.TOOLTIP"
  productWarrantyHint = false;

  activityServiceTicketHintMsg = "VIEW.ACTIVITY.SERVICE.TICKETS.TOOLTIP"
  activityServiceTicketHint = false;

  errorCodesHintMsg = this.commonUtil.replaceValueAsHTMLOnTranslatedText('ERROR.CODES.TOOLTIP',['<a style="color:#4196b4" href="https://www.halo.fitness/web/halo.html#/landing" target="_blank">'+'halo.fitness'+'</a>']) 
  errorCodesHint = false;

  hasEditPermission = false;
  routeParam:string;
  @ViewChild(ConfirmationModalPopupComponent) modalComponent: ConfirmationModalPopupComponent;
  @ViewChild('mainContainerRef', { static: false }) _mainContainerRef: ElementRef;
  
  constructor(
    private commonUtil: CommonUtil,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: ServicePageService,
    private toast: HaloToastService,
    private facilityService: FacilityService
  ) {}

  ngOnInit(): void {
    this.currentFacility = this.facilityService.selectedFacility();
    const facilityChanges = this.facilityService.selectedFacilitySource.subscribe((val) => {
      this.currentFacility = val;
      this.hasEditPermission = this.currentFacility.summary.isLoggedInManagerAdmin === 'true' || this.currentFacility.summary.userRights.isAdmin === 'true' || this.currentFacility.summary.userRights.serviceNotice === 'F';
      this.initData();
      this.getData();
      this.filterData(this.maintenanceData[0], this.maintenanceData[0].tabData);
      this.filterData(this.maintenanceData[1], this.maintenanceData[1].tabData);
      this.filterData(this.maintenanceData[2], this.maintenanceData[2].tabData);   
      
      const popupData = this.facilityService.getAnnouncements();
      this.productWarrantyHint = popupData.showProductWarrantyTooltip;
      this.activityServiceTicketHint = popupData.showServiceTicketsActivityTooltip;
      this.errorCodesHint = this.currentFacility.summary.isPlanetFitness === "true" && popupData.showErrorCodesTooltip;
      this.resetCircleTooltipHintPosition();
    });
    this.sub.add(facilityChanges);
    this.rootScopeData = this.commonUtil.rootScopeData;
    this.initData();
    this.getData();

    const popupData = this.facilityService.getAnnouncements();
    this.productWarrantyHint = popupData.showProductWarrantyTooltip;
    this.activityServiceTicketHint = popupData.showServiceTicketsActivityTooltip;
    this.errorCodesHint = this.currentFacility.summary.isPlanetFitness === "true" && popupData.showErrorCodesTooltip;
    this.hasEditPermission = this.currentFacility.summary.isLoggedInManagerAdmin === 'true' || this.currentFacility.summary.userRights.isAdmin === 'true' || this.currentFacility.summary.userRights.serviceNotice === 'F';

    const activatedRouteSub = this.activatedRoute.params.subscribe(params => {
      if(params['action']){
        this.routeParam = params['action'];
        this.resetCircleTooltipHintPosition();
      }               
    })
    this.sub.add(activatedRouteSub);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onToggleCollapse(event: any, table: any) {
    this.maintenanceData.forEach(m => m.isSelected = false);
    table.isSelected = event.target.getAttribute('aria-expanded') !== 'true';
    this.resetCircleTooltipHintPosition();   
  }

  resetCircleTooltipHintPosition(){    
    setTimeout(() => {
      const mainContainerRef = this._mainContainerRef.nativeElement.getBoundingClientRect();        
      if((document.getElementById("service_ticket") as HTMLElement)){
        const serviceTicketRect = (document.getElementById("service_ticket") as HTMLElement).getBoundingClientRect();
        if(this.activityServiceTicketHint) (document.getElementsByClassName("activityServiceTicketHint")[0] as HTMLElement).style.top = (serviceTicketRect.top - (mainContainerRef.top+13)) + "px";
      } 
      
      
      if((document.getElementById("error_codes") as HTMLElement)){
        const errorCodesRect = (document.getElementById("error_codes") as HTMLElement).getBoundingClientRect();
        if(this.errorCodesHint) (document.getElementsByClassName("errorCodesHint")[0] as HTMLElement).style.top = (errorCodesRect.top - (mainContainerRef.top+13)) + "px";
      }  
    }, 1000);
  }

  onSelectionChange(selectionInfo:any){
    this.selectionInfo = selectionInfo;
  }

  navigateFunction(link: string[]) {
    this.router.navigate(link);
  }

  paginationChanged(event: any) {
    if (!event) return
    const table = this.maintenanceData.find(m => m.id === event.id);
    if (!table) return;
    table.currentPage = event.currentPage;
    table.rowsPerPage = event.rowsPerPage;
    this.filterData(table, table.tabData);
  }

  onErrorCodesComplete(errorCode: any) {
    this.selectedErrorCodes = errorCode;
    this.showErrorCodesCompleteModal = true;
  }

  onComplete(data: any) {
    this.selectedInspectBelt = data;
    this.showCompleteModal = true;
  }

  onDismiss(data: any) {
    this.selectedInspectBelt = data;
    this.showDismissModal = true;
    // allow the current process to end before processing the showing of modal
    setTimeout(() => {            
      this.modalComponent.show(true).then(async res => {
        this.showDismissModal = false;
        if(res == 1) {// YES
          const cmpObj = {
            "action": "dismiss",
            "activityType": this.selectedInspectBelt.activityType,
            "assetId": this.selectedInspectBelt.assetId,
            "completedTimestamp":new Date().getTime(),
            "completedUserName": this.rootScopeData.currentUser.displayName,
            "facilityId": Number(this.currentFacility.facilityId),
            "userEmail": this.rootScopeData.currentUser.emailAddress
          }
          try {
            this.customLoaderIsLoading = true;
            await this.service.updateInspectBelts(cmpObj,this.currentFacility);
            this.toast.creatToast(this.commonUtil.translateText('JOB.ORDER.CLOSED'));
            await this.processInspectBelt();
          } catch (error) {
            console.error('API failed.')
          }
          this.customLoaderIsLoading = false;
        }
      });
    });
  }


  onViewEquipment(data: any) {
    this.router.navigate(['facility/product_info/', data.assetId, true]);
  }

  onSearch(search: string, table: any) {
    if (table.search != undefined) {
      table.search = search.toLowerCase();
      table.tabData = table.rawTabData.filter((d:any)=>d.jobName.toLowerCase().includes(table.search)||d.equipmentType.toLowerCase().includes(table.search));
    }
    this.filterData(table, table.tabData);
  }

  onSort(sortBy: string, sortType: string, table: any) {
    if(table.sortBy === sortBy) table.sortOrder = table.sortOrder === 'asc' ? 'desc' : 'asc';
    else {
      table.sortBy = sortBy;
      table.sortType = sortType;
      table.sortOrder = 'asc';
    }
    this.sortData(table);
    this.filterData(table, table.tabData);
  }

  onWorkOrderTabChanged(tab: string, table: any) {
    if(table.selectedTab === tab) return;
    table.selectedTab = tab;
    if (tab === 'Closed') table.rawTabData = table.rawData.filter((d:any)=>d.status==='Closed');
    else if (tab === 'Active') table.rawTabData = table.rawData.filter((d:any)=>d.status!=='Closed');
    else table.rawTabData = table.rawData;
    table.tabData = table.rawTabData;
    this.sortData(table);
    this.onSearch(table.search, table);
  }

  async onCompleted(data: any) {
    this.showCompleteModal = false;
    try {
      this.customLoaderIsLoading = true;
      await this.service.updateInspectBelts(data,this.currentFacility);
      await this.processInspectBelt();
    } catch (error) {
      console.error('API failed.')
    }
    this.customLoaderIsLoading = false;
  }

  async onErrorCodesCompletedOrDismissed(data: any) {
    this.showErrorCodesCompleteModal = false;
    try {
      this.customLoaderIsLoading = true;
      await this.service.updateErrorCodes(data,this.currentFacility);
      await this.processErrorCodes();
    } catch (error) {
      console.error('API failed.')
    }
    this.customLoaderIsLoading = false;
  }

  private filterData(table: any, dataSource: any) {
    setTimeout(() => {
      const startIndex = (table.currentPage - 1) * table.rowsPerPage;
      let endIndex = table.currentPage * table.rowsPerPage;
      endIndex = dataSource.length > endIndex ? endIndex : dataSource.length;
      table.filteredData = [];
      for (let index = startIndex ; index < endIndex; index++) {
        table.filteredData.push(dataSource[index]);
      }
    });
  }

  private initData() {
    this.maintenanceData = [
      {name: 'INSPECT.BELT', id: 'inspect_belt', count: 0, filteredData: []},
      {name: 'ACTIVE.SERVICE.TICKETS', id: 'service_ticket', count: 0, filteredData: []},
      {name: 'ERROR.CODES', id: 'error_codes', count: 0, filteredData: [],isHidden: this.currentFacility.summary.isPlanetFitness === "true" ? false : true}      
    ];
  }

  private sortData(table: any) {
    if (table.sortOrder === 'asc') {
      if (table.sortType === 'alphabetical') {
        if(table.sortBy === 'assignedTo') {
          table.tabData = table.tabData.sort((a: any, b:any) => a.assigneeVO.displayName?.toUpperCase() < b.assigneeVO.displayName?.toUpperCase() ? 1 : -1);
        } if(table.sortBy === 'typeStatus') {
          table.tabData = table.tabData.sort((a: any, b:any) => a.equipmentType?.toUpperCase() < b.equipmentType?.toUpperCase() 
          && a.status?.toUpperCase() < b.status?.toUpperCase()? 1 : -1);
        } else {
          table.tabData = table.tabData.sort((a: any, b:any) => a[table.sortBy]?.toUpperCase() < b[table.sortBy]?.toUpperCase() ? 1 : -1);
        }
      }
      else table.tabData = table.tabData.sort((a: any, b:any) => a[table.sortBy] - b[table.sortBy]);
    } else {
      if (table.sortType === 'alphabetical') {
        if(table.sortBy === 'assignedTo') {
          table.tabData = table.tabData.sort((a: any, b:any) => a.assigneeVO.displayName?.toUpperCase() > b.assigneeVO.displayName?.toUpperCase() ? 1 : -1);
        } if(table.sortBy === 'typeStatus') {
          table.tabData = table.tabData.sort((a: any, b:any) => a.equipmentType?.toUpperCase() > b.equipmentType?.toUpperCase() 
          && a.status?.toUpperCase() < b.status?.toUpperCase() ? 1 : -1);
        } else {
          table.tabData = table.tabData.sort((a: any, b:any) => a[table.sortBy]?.toUpperCase() > b[table.sortBy]?.toUpperCase() ? 1 : -1);
        }
      }
      else table.tabData = table.tabData.sort((a: any, b:any) => b[table.sortBy] - a[table.sortBy]);
    } 
  }

  private async getData() {
    this.customLoaderIsLoading = true;
    const list = await Promise.all([this.processInspectBelt(), this.processServiceRequest(),this.processErrorCodes()]);   
    if(list.findIndex(val => val === 'API failed')>-1){
      this.service.getCounts(this.currentFacility);
    }
    this.customLoaderIsLoading = false;  
  }

  async processInspectBelt() {
    this.maintenanceData[0].count = 0;
    try {
      this.maintenanceData[0].rawData = await this.service.getInspectBelts(this.facilityService.selectedFacilityId());
    } catch (error) {
      this.maintenanceData[0].rawData = [];
      this.maintenanceData[0].filteredData = [];
      return 'API failed';
    }
    this.maintenanceData[0].tabData = this.maintenanceData[0].rawData;
    this.maintenanceData[0].isSelected = this.maintenanceData[0].tabData?.length == 0 ? false : this.maintenanceData[0].isSelected;
    if(this.maintenanceData[0].tabData?.length == 0) this.hideAccordion(this.maintenanceData[0]);
    if(!this.maintenanceData[0].rawData || this.maintenanceData[0].rawData.length < 1) return;
    this.maintenanceData[0].count = this.maintenanceData[0].rawData.length;
    this.maintenanceData[0].rawData.forEach((d: any) => {
      if(d.consoleType && d.modelId) d.image = this.commonUtil.imgSrcGenerate(d.modelId, this.getConsoleType(d.consoleType), false);
    });
    return this.maintenanceData[0];
  }

  async processServiceRequest() {
    this.maintenanceData[1].count = 0;
    try {
      this.maintenanceData[1].rawData = await this.service.getServiceRequests(this.facilityService.selectedFacilityId());
    } catch (error) {
      this.maintenanceData[1].rawData = [];
      this.maintenanceData[1].filteredData = [];
      return 'API failed';
    }
    this.maintenanceData[1].tabData = this.maintenanceData[1].rawData;
    this.maintenanceData[1].isSelected = this.maintenanceData[1].tabData?.length == 0 ? false : this.maintenanceData[1].isSelected;
    if(this.maintenanceData[1].tabData?.length == 0) this.hideAccordion(this.maintenanceData[1]);
    if(!this.maintenanceData[1].rawData || this.maintenanceData[1].rawData.length < 1) return;
    this.maintenanceData[1].count = this.maintenanceData[1].rawData.length;
    this.maintenanceData[1].rawData.forEach((d: any) => {
      if(d.consoleType && d.modelId) d.image = this.commonUtil.imgSrcGenerate(d.modelId, this.getConsoleType(d.consoleType), false);
    });
    return this.maintenanceData[1];
  }

  async processErrorCodes() {
    if(this.maintenanceData[2].isHidden) return;
    this.maintenanceData[2].count = 0;
    this.maintenanceData[2].selected = false;
    try {
      let errorCodes:any = await this.service.getErrorCodes(this.facilityService.selectedFacilityId());    
      let preparedAssetErrorsList = []; 

      if(errorCodes.assetErrorsList){
        let assetErrorsList = errorCodes.assetErrorsList;
        let allErrorCodeDetailsList = errorCodes.allErrorCodeDetailsList;     
        preparedAssetErrorsList = assetErrorsList.map((val:any) => ({ assetId: val.asset.assetId,bodySerial: val.asset.bodySerial,activityId:val.asset.activityId,displayName:val.asset.displayName,consoleType: val.asset.consoleType,modelId:val.asset.modelId,errorCodes:val.errorCodes,expanded:false})) as any;
       
        preparedAssetErrorsList.forEach((val:any) => {
          val.errorCodes.forEach((err:any) => {
            const errorDetails = allErrorCodeDetailsList.find((details:any) => details.code.toString() === err.code.toString());
            err.errorDetails = errorDetails;
            err.activityId = val.activityId;
            err.bodySerial = val.bodySerial;
            err.displayName = val.displayName;
            err.assetId = val.assetId;
            if(errorDetails.troubleshooting){
              err.troubleshooting = Object.values(errorDetails.troubleshooting)[0];
            }          
          });
        });
      } 
      this.maintenanceData[2].rawData = preparedAssetErrorsList;    
    } catch (error) {
      this.maintenanceData[2].rawData = [];
      this.maintenanceData[2].filteredData = [];
      return 'API failed';
    }
    if(!this.maintenanceData[2].rawData || this.maintenanceData[2].rawData.length < 1) return;
    let count = 0;
    this.maintenanceData[2].rawData.forEach((d: any) => {
      count += d.errorCodes.length;
      if(d.consoleType && d.modelId) d.image = this.commonUtil.imgSrcGenerate(d.modelId, this.getConsoleType(d.consoleType), false);
    });
    this.maintenanceData[2].count = count;
    this.maintenanceData[2].tabData = this.maintenanceData[2].rawData;
    this.maintenanceData[2].filteredData = this.maintenanceData[2].rawData;

    return this.maintenanceData[2];
  }

  getConsoleType(consoleName: string) {
    let consoleType = '';
    this.rootScopeData.consoleRights.forEach((v,k) => {
      if(v.consoleName === consoleName) consoleType = v.consoleType;
    });
    return consoleType;
  }

  onCloseProductWarrantyHint(){
    this.facilityService.setAnnouncementsState('showProductWarrantyTooltip', false);   
    this.productWarrantyHint = false;  
  }
  
  onCloseActivityServiceTicketHint(){
    this.facilityService.setAnnouncementsState('showServiceTicketsActivityTooltip', false);  
    this.activityServiceTicketHint = false;      
  }

  onCloseErrorCodesHint(){
    this.facilityService.setAnnouncementsState('showErrorCodesTooltip', false);  
    this.errorCodesHint = false;      
  }

  private hideAccordion(table: any) {
    setTimeout(() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      $(`#collapse${table.id}`).collapse('hide');
    }, 100);
  }
}
